export default {
  // 主键 a-z A-Z 0-9 _-
  primary: {
    validator: /^[a-zA-Z0-9_-]+$/,
    message: '{{label}} 只能为数字、字母的组合',
  },

  word: {
    validator: /^[a-zA-Z_-]+$/,
    message: '{{label}} 只能为英文字母',
  },

  email: {
    validator: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
    message: '请填写正确的邮箱地址',
  },

  phone: {
    validator: /^((0\d{2,3}\d{7,8})|(0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/,
    message: '请填写正确的电话号码',
  },

  url: {
    validator: /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,
    message: '请填写正确的网址',
  },
  // cards: {
  //     validator: /^([0-9ABCDEFGHJKLMNPQRTUWXY]{2})([0-9]{6})([0-9ABCDEFGHJKLMNPQRTUWXY]{9})([0-9Y])$/,
  //     message: '请填写正确的统一社会信用代码',
  // },
  // idcard: {
  //     validator: /^([0-9ABCDEFGHJKLMNPQRTUWXY]{2})([0-9]{6})([0-9ABCDEFGHJKLMNPQRTUWXY]{9})([0-9Y])$/,
  //     message: '请填写正确的身份证号',
  // }
}
